export const SQUID = "squid";
export const SCHEDULED = "scheduled";
export const ALL_GRIDS = "All grids";
